import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const STAFF = ["super_admin", "admin", "content_editor", "coach"];

export default function ProtectedRoute({ children, allow }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="section-label text-[11px] text-zinc-500 animate-pulse" data-testid="auth-loading">
          Loading…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) return <Navigate to="/learn" replace />;
  return children;
}

export { STAFF };
